// extracted by mini-css-extract-plugin
module.exports = {"camera":"camera--Csb9_","show":"show--3J4VD","video":"video--3izc7","mask":"mask--PmJxN","close":"close--16dgR","icon":"icon--fPzKJ","shot":"shot--3qq3O"};